module.exports = __webpack_public_path__ + "static/img/6.a2195e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting584/images/6.png
// module id = Swzp
// module chunks = 4